import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';


// 🔹 Import jQuery first
import $ from 'jquery';

// Import CSS first
import 'bootstrap/dist/css/bootstrap.min.css';

// Import JS bundle
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';


// Header.tsx (or in index.tsx)
//import 'datatables.net-dt/css/jquery.dataTables.min.css';
//import 'https://uxcomplib.iaai.com/CompLib/2.3/css/iaa-pattern-library.min.css';
//import './public/bundles/coreCSSNoHeaderad80.css';
import './assets/work/bundles/coreCSSNoHeaderad80.css';
import './assets/work/bundles/headerCSS28d6.css';
//import './assets/work/prod/css/pages/registration.min.css';
//import './assets/work/prod/css/pages/iaa-pattern-library.minecc1.css';
import './assets/work/prod/css/pages/terms-of-use.css';
//import './assets/work/prod/css/pages/search.css';
import './assets/work/prod/css/pages/introjs.css';
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Header.tsx


// import * as signalR from '@microsoft/signalr';
// import 'swiper/swiper-bundle.min.js';
// import 'intro.js/introjs.css'; // CSS for intro.js
// import 'intro.js/intro.js';

import './assets/work/bundles/coreJS1ff3.js';
//import './assets/work/bundles/Knockoutjs1763.js';
//import './assets/work/bundles/BDTglobaljsfc94.js';
//import './assets/work/prod/js/SearchPage1bc9.js';

// expose jQuery globally (REQUIRED for legacy scripts)
window.$ = $;
window.jQuery = $;


// 🔹 Load remote CSS dynamically (cannot import as a module)
const iaaCss = document.createElement("link");
iaaCss.rel = "stylesheet";
iaaCss.href =
  "https://uxcomplib.iaai.com/CompLib/2.3/css/iaa-pattern-library.min.css";
document.head.appendChild(iaaCss);


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export {};